import { request } from './http';

export async function getVerificationLinks(verificationId) {
    return request(`/verifications/audits/${verificationId}/links`);
  }

export async function addVerificationLink(verificationId, linkData) {
    return request(`/verifications/audits/${verificationId}/links`, {
      method: 'POST',
      body: JSON.stringify(linkData),
    });
  }

export async function deleteVerificationLink(verificationId, linkId) {
    return request(`/verifications/audits/${verificationId}/links/${linkId}`, {
      method: 'DELETE',
    });
  }

export const auditLinksApi = {
  getVerificationLinks,
  addVerificationLink,
  deleteVerificationLink,
};

